import styled from 'styled-components';

export const StyledHeader1 = styled.h1`
    display: inline-block
    margin-top: 10px;
    font-family: Satoshi, "Open Sans", "Helvetica Neue", Helvetica, Arial, cursive, sans-serif !important;
    font-weight: 400;
    font-size: 24px;
    color: #382757;
    line-height: 25px;
    padding-left: 20px;
    padding-top: 15px;
`

export const RatingStyle = styled.h3`
    display: inline-block;
    font-family: Satoshi, "Open Sans", "Helvetica Neue", Helvetica, Arial, cursive, sans-serif !important;
    font-weight: 700;
    font-size: 18px;
    color: #382757;
    line-height: 15px;
    padding-left: 20px;
    padding-right: 10px;
`
export const CaptionStyle = styled.h3`
    display: inline-block;
    font-family: Satoshi, "Open Sans", "Helvetica Neue", Helvetica, Arial, cursive, sans-serif !important;
    padding-left: 20px;
    font-weight: 300;
    font-size: 18px;
    color: #382757;
    line-height: 15px;
`

export const StyledButton = styled.button`
    font-family: Satoshi;
    margin-top: 0px !important;
    background-color: rgb(56, 39, 87);
    color: rgb(255, 255, 255);
    border: 1px solid rgb(56, 39, 87);
    border-radius: 100px;
    padding: 8px 22px;
    padding-top: 8px;
    font-size: 15px;
    font-align: center;
    font-vertical-align: middle;
    min-width: fit-content;
    margin-left: 20px;
    height: 100%;
`;